// A full-height cell at the right of the top bar (star, task status, bell,
// avatar), split by a line on its left, like the Menu button and market block
// on the left side. The whole cell is the click target and darkens on hover or
// while its box or menu is open.
export const TOP_BAR_CELL =
  "relative flex h-full flex-shrink-0 items-center justify-center gap-1.5 border-l border-border px-4 transition-colors hover:bg-muted data-[state=open]:bg-muted focus-visible:bg-muted focus-visible:outline-none"
